export const GET_ALL_MODULES = 'GET_ALL_MODULES'
export const GET_MODULE = 'GET_MODULE'
export const CREATE_MODULE = 'CREATE_MODULE'
export const UPDATE_MODULE = 'UPDATE_MODULE'
export const DELETE_MODULE = 'DELETE_MODULE'
export const CLEAR_MODULES = 'CLEAR_MODULES'

export const CREATE_MODULE_ITEM = 'CREATE_MODULE_ITEM'
export const UPDATE_MODULE_ITEM = 'UPDATE_MODULE_ITEM'
export const DELETE_MODULE_ITEM = 'DELETE_MODULE_ITEM'

export const LOADING_UPLOAD = 'LOADING_UPLOAD'
